<template>
  <div class="app-container" id="screen-layout">
    <!-- 顶部菜单 -->
    <Header />
    <!-- 主要内容区域 -->
    <div class="main-content">
      <router-view v-slot="{ Component }">
        <transition name="fade" mode="out-in">
          <component :is="Component" />
        </transition>
      </router-view>
    </div>
    <!-- 底部 -->
    <Footer />
    <Affiliation />
  </div>
</template>

<script>
import Header from '@/components/header/index.vue'
import Footer from '@/components/footer/index.vue'
import Affiliation from '@/components/affiliation/index.vue'

export default {
  components: {
    Header,
    Footer,
    Affiliation
  }
}
</script>

<style>
.app-container {
  display: flex;
  flex-direction: column;
  position: relative;
}


</style>
